import { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import Image from 'components/Image';
import { useScrollRestore } from 'hooks';
import {
  ProjectContainer,
  ProjectSection,
  ProjectSectionContent,
  ProjectImage,
  ProjectTextRow,
  ProjectSectionHeading,
  ProjectSectionText,
  ProjectHeader,
  ProjectSectionColumns,
} from 'components/ProjectLayout';
import sliceApp from 'customAssets/twickCollage1.jpg';
import sliceAppPlaceholder from 'assets/slice-app-placeholder.jpg';
import sliceSidebarLayers from 'customAssets/twick1.jpg';
import sliceSidebarLayersPlaceholder from 'assets/slice-sidebar-layers-placeholder.png';
import sliceSidebarAnnotations from 'customAssets/twick2.jpg';
import sliceSidebarAnnotationsPlaceholder from 'assets/slice-sidebar-annotations-placeholder.png';
import sliceSlides from 'customAssets/twickCollage2.jpg';
import sliceSlidesPlaceholder from 'assets/slice-slides-placeholder.jpg';

import { media } from 'utils/style';
import './index.css';
import { EndFooter } from 'pages/Home/footer/footer';
import { appJoxDescription, appJoxTitle } from 'pages/Home';

const title = 'One of the best Social Media Apps';
const description =
  'Twick is my vision on what social media apps should look like. This app consists of beautiful designs, smooth animations, and an intuitive user experience. For me, it was a treat to work on and we had a lot of fun developing it!';
const roles = [
  'Product Architecture',
  'UX and UI Design',
  'Front End Development',
  'Back End Development',
];

const Twick = () => {
  useScrollRestore();

  return (
    <Fragment>
      <Helmet>
        <title>{`Projects | ${title}`}</title>
        <meta name="description" content={description} />
        <meta name="og:description" content={description} />
        <meta
          property="og:image"
          content="https://i.ibb.co/WtQsRdm/Screenshot-2022-02-15-204105.png"
        />{' '}
        <meta property="og:title" content={`Projects | ${title}`} />
        <meta name="twitter:description" content={appJoxDescription} />
        <meta name="twitter:title" content={appJoxTitle} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:image"
          content="https://i.ibb.co/WtQsRdm/Screenshot-2022-02-15-204105.png"
        />
      </Helmet>
      <ProjectContainer className="slice">
        <ProjectHeader title={title} description={description} roles={roles} />
        <ProjectSection first>
          <ProjectSectionContent>
            <ProjectImage
              srcSet={sliceApp}
              placeholder={sliceAppPlaceholder}
              alt="Twick App"
              sizes={`(max-width: ${media.mobile}px) 100vw, (max-width: ${media.tablet}px) 90vw, 80vw`}
            />
          </ProjectSectionContent>
        </ProjectSection>
        <ProjectSection>
          <ProjectSectionColumns centered className="slice__columns">
            <div className="sidebar__images-text">
              <ProjectSectionHeading>Simple is Beautiful</ProjectSectionHeading>
              <ProjectSectionText>
                This app represents how we like to design our apps. We firmly believe that
                keeping things simple makes them beautiful.
              </ProjectSectionText>
              <ProjectSectionText>
                Keeping things minimal provides an app that is easy to use and pleasing to
                the eyes.
              </ProjectSectionText>
            </div>
            <div className="slice__sidebar-images">
              <Image
                className="slice__sidebar-image"
                srcSet={sliceSidebarLayers}
                placeholder={sliceSidebarLayersPlaceholder}
                alt="Twick App"
                sizes={`(max-width: ${media.mobile}px) 200px, 343px`}
              />
              <Image
                className="slice__sidebar-image"
                srcSet={sliceSidebarAnnotations}
                placeholder={sliceSidebarAnnotationsPlaceholder}
                alt="Twick App"
                sizes={`(max-width: ${media.mobile}px) 200px, 343px`}
              />
            </div>
          </ProjectSectionColumns>
        </ProjectSection>
        <ProjectSection light>
          <ProjectSectionContent>
            <ProjectTextRow>
              <ProjectSectionHeading>Industrial Technologies</ProjectSectionHeading>
              <ProjectSectionText>
                We know that social media apps should be able to accommodate heavy loads.
                That's why we have used MongoDB for the database, S3 for cloud storage and
                Firebase for authentication.
              </ProjectSectionText>
            </ProjectTextRow>
            <Image
              srcSet={sliceSlides}
              placeholder={sliceSlidesPlaceholder}
              alt="Twick App"
              sizes={`(max-width: ${media.mobile}px) 500px, (max-width: ${media.tablet}px) 800px, 1000px`}
            />
          </ProjectSectionContent>
        </ProjectSection>
      </ProjectContainer>
      <EndFooter />
    </Fragment>
  );
};

export default Twick;
